import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimeLeftPipe } from './time-left.pipe';
import { SafePipe } from './safe.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        TimeLeftPipe,
        SafePipe,PhoneNumberPipe
    ],
    exports: [
        TimeLeftPipe,
        SafePipe,
        PhoneNumberPipe
    ]
})
export class PipesModule { }
